import React from 'react';
import { Container, Heading, Item, Description } from './styles';

const UserImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/user.svg';
const CalendarImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/ScheduleDate.svg';
const PaymentImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/money.svg';
const CarImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/car-front.svg';
const LocationImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/location.svg';
const HouseImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/location.svg';
const CameraImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/Camera.svg';
const diuInsertGrayIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/diu-insert-gray.svg';
const diuRemoveGrayIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/diu-remove-gray.svg';
const medicineBagGrayIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/medicine-bag-gray.svg';
const stethoscopeGrayIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/stethoscopeIcon.svg';
const stethoscopeIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/estetoscopio.svg';
const medicineBagIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/medicine-bag.svg';
const vaccineImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/vacinaEsquerda.svg';
const preNatalIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/pre-natal.svg';
const preNatalGrayIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/pre-natalGray.svg';

import { HorizontalLine } from '../../../components/HorizontalLine';
import { Unit } from '../../../components/ServiceItem';

import { PAYMENT, ScheduleItemProps, typeLocationSchedule } from '../../../models/Schedule';
import { PatientProps } from '../../../contexts/PatientContext';
import { formatDatetime } from '../../../utils/dates';
import { ProductItemProps } from '../../../models/Product';
import { PAYMENT_TYPE, SchedulesTypes } from '../../../utils/constants';
import ProfessionalCard from '../ProfessionalCard';
import { handleProductName } from '../../../utils';
import { ItemToScheduleType, useModuleContext } from '../../../contexts/ModuleContext';

export type ScheduleData = {
  unit: Unit | undefined;
  schedule: ScheduleItemProps;
  patient: PatientProps;
  product: ProductItemProps;
  selectedServiceId: string;
};

export const AppointmentConfirmationCard = ({ unit, schedule, patient, product, selectedServiceId }: ScheduleData) => {
  let formatedDatetime;
  let payment;

  if (schedule.time) formatedDatetime = formatDatetime(schedule.time.time);
  if (schedule.payment) payment = schedule.payment;
  const isParticular = payment?.type === PAYMENT_TYPE.PARTICULAR || payment?.type === PAYMENT.PARTICULAR;
  const isB2B = payment?.type === PAYMENT_TYPE.B2B;
  const isHealthPlan = payment?.type === PAYMENT_TYPE.HELTH_INSURANCE || payment?.type === PAYMENT.HEALTH_INSURANCE;

  const isDriveThru = schedule.careType === typeLocationSchedule.DRIVE_THRU;
  const isPresential =
    schedule.careType === typeLocationSchedule.PRESENTIAL || schedule.careType === typeLocationSchedule.PROCEDURE;
  const isEav = schedule.careType === typeLocationSchedule.EINSTEIN_TO_YOU;
  const isTele = schedule.careType === typeLocationSchedule.TELEMEDICINE;
  const isPrenatal =
    (product.name === 'Médico da Família' || product.name === 'Enfermeiro da Família') && patient.pregnant;

  const { selectedItemToSchedule } = useModuleContext();
  const getIcon = (icon: string): any => {
    return `https://agendamento-images-nprd.telemedicinaeinstein.com.br/icons/${icon}`;
  };

  const getHeadingIconByProductName = (productName: string): any => {
    const icon = {
      'Médico da Família': isPrenatal ? preNatalIcon : stethoscopeIcon,
      'Enfermeiro da Família': isPrenatal ? preNatalIcon : medicineBagIcon,
      'Pré-natal': preNatalIcon,
      'Inserção de DIU': diuInsertGrayIcon,
      'Remoção de DIU': diuRemoveGrayIcon
    }[productName];

    if (icon) return icon;
    return vaccineImg;
  };

  const getServiceIconByProductName = (productName: string): any => {
    const icon = {
      'Médico da Família': isPrenatal ? preNatalGrayIcon : stethoscopeGrayIcon,
      'Consulta médica': stethoscopeGrayIcon,
      'Consulta de retorno': stethoscopeGrayIcon,
      'Primeira consulta': stethoscopeGrayIcon,
      'Enfermeiro da Família': isPrenatal ? preNatalGrayIcon : medicineBagGrayIcon,
      'Inserção de DIU': diuInsertGrayIcon,
      'Remoção de DIU': diuRemoveGrayIcon
    }[productName];

    if (icon) return icon;
    return stethoscopeGrayIcon;
  };

  const getDescriptionByScheduleType = (scheduleType: string): any => {
    const description: { [key: string]: string } = {
      IMMUNIZATION: 'Vacinas',
      PROCEDURE: isPrenatal ? 'Consulta - Pré Natal' : 'Equipe do cuidado',
      EXAM: 'Exames'
    };
    return description[scheduleType];
  };

  const formatProductName = (name: string) => {
    if (schedule.scheduleType === SchedulesTypes.APPOINTMENT || schedule.scheduleType === SchedulesTypes.CONSULTATION) {
      if (schedule.careType !== typeLocationSchedule.PROCEDURE) {
        if (isPrenatal) return `Consulta ${name} - Pré Natal`;
        return `Consulta  - ${name}`;
      }
    }
    return name;
  };

  const handleHeaderIcon = () => {
    if (isPrenatal || !product.icon) {
      return <img src={getHeadingIconByProductName(product.name)} alt={product.name} />;
    } else {
      return (
        <div className="icon-wrapper">
          <img src={getIcon(product.icon)} alt="product-icon" />
        </div>
      );
    }
  };

  const checkShowSpecialist = ({ isSpecialist }: { isSpecialist: boolean }) => {
    if (isSpecialist && !product.coverages?.some(item => item.category !== 'EXAM')) return true;
    if (
      selectedServiceId === process.env.REACT_APP_SERVICE_ID &&
      !product.coverages?.some(item => item.category !== 'EXAM')
    )
      return true;
    return false;
  };

  return (
    <Container>
      {/* ------------------------- 
            Specialist or Product
      ------------------------- */}
      {checkShowSpecialist({ isSpecialist: !!schedule.useResouce && !!schedule.resource }) ? (
        <ProfessionalCard
          resource={schedule.useResouce ? schedule.resource : undefined}
          resourceSlot={schedule.selectedSlotOptions?.[0]}
          productName={handleProductName(schedule.productName || '') || ''}
        />
      ) : (
        <Heading>
          {handleHeaderIcon()}
          <div>
            <p className="product-name">{handleProductName(product.name)}</p>
            {schedule.scheduleType && (
              <p className="product-description">{getDescriptionByScheduleType(schedule.scheduleType)}</p>
            )}
          </div>
        </Heading>
      )}

      <HorizontalLine />

      {/* ------------------------- 
            Patient Information
      ------------------------- */}
      <Item>
        <img src={UserImg} alt="patient" />
        <p>{patient.name}</p>
      </Item>

      {/* ------------------------- 
            Service Types 
      ------------------------- */}
      {schedule.useResouce && schedule.resource && (
        <Item>
          <img src={getServiceIconByProductName(product.name)} alt={product.name} />
          <p>{formatProductName(product.name)}</p>
        </Item>
      )}

      {/* ------------------------- 
            Date and Hour
      ------------------------- */}
      <Item>
        <img src={CalendarImg} alt="date-and-hour" />
        <p>{formatedDatetime}</p>
      </Item>

      {/* ------------------------- 
            Payment Types 
      ------------------------- */}
      {isB2B && (
        <Item>
          <img src={PaymentImg} alt="payment-eligibility" />
          <p>{payment?.eligibility?.plan ?? isHealthPlan}</p>
        </Item>
      )}

      {isHealthPlan && (
        <>
          <Item>
            <img src={PaymentImg} alt="payment-eligibility" />
            <p>Pagamento</p>
          </Item>
          <Description style={{ marginBottom: 8 }}>{schedule.payment?.healthInsurance?.name}</Description>
        </>
      )}

      {isParticular && (
        <>
          <Item>
            <img src={PaymentImg} alt="payment-particular" />
            <div>
              <p>Pagamento particular</p>
            </div>
          </Item>
          {selectedItemToSchedule === ItemToScheduleType.SPECIALIST && (
            <Description>Verifique as opções aceitas pelo profissional no dia do atendimento</Description>
          )}
        </>
      )}

      {/* ------------------------- 
            Attendance Types 
      ------------------------- */}
      {isDriveThru && (
        <Item>
          <img src={CarImg} alt="drive-thru" />
          <p>Drive-thru</p>
        </Item>
      )}

      {(isPresential || isDriveThru) && !!unit && (
        <>
          <Item>
            <img src={LocationImg} alt="unit-details" />
            <p>{unit.name}</p>
          </Item>
          <Description>
            {unit.address}
            {unit.address_number ? `, ${unit.address_number}` : ''}
            <br />
            {unit.neighborhood ? unit.neighborhood : ''}
            {unit.city ? `, ${unit.city}` : ''}
            {unit.state ? ` - ${unit.state}` : ''}
          </Description>
        </>
      )}

      {isEav && (
        <>
          <Item>
            <img src={HouseImg} alt="eav-details" />
            <p>Einstein até você</p>
          </Item>
          {/* <Description>
            Rua Exemplo, 00
            <br />
            Bairro exemplo, Cidade - UF
          </Description> */}
        </>
      )}

      {isTele && (
        <Item>
          <img src={CameraImg} alt="telemedicine" />
          <p>Consulta por telemedicina</p>
        </Item>
      )}
    </Container>
  );
};
